import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import { metricsDetails } from '@/constants';
import { MetricType } from '@/constants/metric-type.enum';
import { toTranslationFormat } from '@/utils/util-functions';

import CustomGauge from './CustomGauge';

interface StationKPICustomGaugeProps {
  entity: {
    index: number;
    metric: MetricType;
    upperThreshold?: number;
    lowerThreshold?: number;
  };
}

const StationKPICustomGauge = observer(({ entity }: StationKPICustomGaugeProps) => {
  const { metric, upperThreshold, lowerThreshold } = entity;
  const { stationStore } = useStores();
  const { t } = useTranslation();
  const { currentStation } = stationStore;

  const getUnit = (): string => {
    return metricsDetails[metric]?.unit;
  };

  const getValue = (): string | number => {
    let value;
    if (metric === MetricType.PressureBar) {
      value = currentStation.kpis?.pressure.currentValue;
    } else if (metric === MetricType.FlowM3Min) {
      value = currentStation.kpis?.flow.currentValue;
    } else if (metric === MetricType.PowerKw) {
      value = currentStation.kpis?.power.currentValue;
    }
    return value ?? '--';
  };

  return (
    <CustomGauge
      title={t(toTranslationFormat(metricsDetails[metric]?.text))}
      value={getValue()}
      unit={getUnit()}
      lowerThreshold={lowerThreshold}
      upperThreshold={upperThreshold}
    />
  );
});

export default StationKPICustomGauge;
